import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './admin-dashboard.css';

function AdminDashboard() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user) {
    navigate('/');
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="admin-dashboard">
      <header className="admin-header">
        <div className="admin-header-content">
          <h1>Admin Dashboard</h1>
          <button className="admin-logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </header>

      <main className="admin-main">
        <section className="admin-welcome">
          <div className="admin-welcome-card">
            <h2>Welcome, {user.name}!</h2>
            <p className="admin-role">Role: <strong>{user.role}</strong></p>
            <p className="admin-email">Email: <strong>{user.email}</strong></p>
          </div>
        </section>

        <section className="admin-stats">
          <div className="stat-card">
            <h3>Users</h3>
            <p className="stat-number">1</p>
          </div>
          <div className="stat-card">
            <h3>Teams</h3>
            <p className="stat-number">0</p>
          </div>
          <div className="stat-card">
            <h3>Players</h3>
            <p className="stat-number">0</p>
          </div>
          <div className="stat-card">
            <h3>Fixtures</h3>
            <p className="stat-number">0</p>
          </div>
        </section>

        <section className="admin-actions">
          <h3>Actions</h3>
          <div className="action-buttons">
            <button className="action-btn">Manage Users</button>
            <button className="action-btn">Manage Teams</button>
            <button className="action-btn">Manage Players</button>
            <button className="action-btn">View Reports</button>
          </div>
        </section>
      </main>
    </div>
  );
}

export default AdminDashboard;
